import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String
  }

  open() {
    const modalId = this.targetValue
    const modalContent = document.getElementById(modalId)
    if (modalContent) {
      const modal = modalContent.firstElementChild
      document.body.appendChild(modal)
      modal.classList.add('modal-open')
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    const modal = this.element.closest('.modal')
    if (modal) {
      modal.classList.remove('modal-open')
      // Wait for the animation to finish before removing
      setTimeout(() => {
        const originalContainer = document.getElementById(this.targetValue)
        if (originalContainer) {
          originalContainer.appendChild(modal)
        }
      }, 300)
    }
  }
} 